import { node, bool } from 'prop-types';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { LOGIN, HOME } from "../../Routes";

// TODO
// - display message for unauthorized access
// - display auth progress
function PrivateRoute ({ children, onlyAdmin }) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const { admin: isAdminUser } = useAuth();

  if( inProgress !== InteractionStatus.None ) {
    return null;
  }

  if(isAuthenticated) {
    if(onlyAdmin) {
      return isAdminUser ? children : <Navigate to={HOME} />
    }
    return children;
  }

  return <Navigate to={LOGIN} />;
}

PrivateRoute.propTypes = {
  children: node.isRequired,
  onlyAdmin: bool,
};

PrivateRoute.defaultProps = {
  onlyAdmin: false,
}

export default PrivateRoute;